import * as Yup from "yup";
import { first } from "lodash-es";
import * as moment from "moment";

const householdMember = Yup.object().shape({
    personInfoScreening: Yup.object().shape({
        willFileJointly: Yup.mixed().test("will-file-jointly-marriage", "Required", function(value) {
            if (!this.parent.planToFileTaxes) {
                return true;
            }

            const existingPerson = first(this.options.context.filter(x => x.personId === this.parent.personId));

            if (existingPerson.maritalStatus === "Single") {
                return true;
            }

            return value === true || value === false;
        }),
        isDisabled: Yup.bool()
            .nullable()
            .test("is-dependent-over-26", "Required", function(value) {
                if (this.parent.willBeClaimedAsDependent === true) {
                    const currentPerson = first(this.options.context.filter(x => x.personId === this.parent.personId));
                    if (currentPerson.age >= 26) {
                        return value != null;
                    }
                }
                return true;
            }),
        planToFileTaxes: Yup.bool()
            .nullable()
            .required("Required"),
        filesJointlyWith: Yup.string().when(["planToFileTaxes", "willFileJointly"], {
            is: true,
            then: Yup.string()
                .nullable()
                .required("Required"),
            otherwise: Yup.string().nullable(),
        }),
        // Write logic here to state that a person can only be a dependent iff. They are under 26 OR disabled
        willBeClaimedAsDependent: Yup.bool()
            .nullable()
            .test("is-required", "Required", function(value) {
                const willFileJointly = this.parent.willFileJointly;
                if (willFileJointly) {
                    return true;
                }

                return value != null;
            }),
        claimedAsADependentBy: Yup.string().when("willBeClaimedAsDependent", {
            is: true,
            then: Yup.string()
                .nullable()
                .required("Required"),
            otherwise: Yup.string().nullable(),
        }),
        income: Yup.object().shape({
            employmentStatus: Yup.array()
                .of(Yup.string())
                .required("Required"),
            employers: Yup.array().when("employmentStatus", {
                is: es => es.indexOf("Employed") >= 0,
                then: Yup.array()
                    .of(
                        Yup.object().shape({
                            employerName: Yup.string().nullable(),
                            frequency: Yup.string().required("Required"),
                            amount: Yup.string().required("Required"),
                            averageHoursWorkedPerWeek: Yup.number().when("frequency", {
                                is: "Hourly",
                                then: Yup.number()
                                    .required("Required")
                                    .typeError("Invalid"),
                                otherwise: Yup.number().nullable(),
                            }),
                        })
                    )
                    .required("Required"),
                otherwise: Yup.array().nullable(),
            }),
            selfEmployment: Yup.object().when("employmentStatus", {
                is: es => es.indexOf("Self-employed") >= 0,
                then: Yup.object().shape({
                    typeOfWork: Yup.string().nullable(),
                    amount: Yup.number()
                        .nullable()
                        .required("Required")
                        .typeError("Invalid"),
                }),
                otherwise: Yup.object().nullable(),
            }),
        }),
        /*incomeInfo: Yup.object().shape({
            doesReceiveIncome: Yup.bool()
                .nullable()
                .required("required"),
            incomes: Yup.array().of(
                Yup.object().shape({
                    incomeType: Yup.string()
                        .nullable()
                        .required("required"),
                    amount: Yup.number()
                        .nullable()
                        .required("required")
                        .typeError("invalid"),
                    frequency: Yup.string()
                        .nullable()
                        .required("required"),
                    averageHoursWorkedPerWeek: Yup.number()
                        .nullable()
                        .when("frequency", {
                            is: "Hourly",
                            then: Yup.number()
                                .typeError("required")
                                .required("required")
                                .min(1, "Invalid"),
                            otherwise: Yup.number().nullable(),
                        }),
                })
            ),
        }), */
    }),
});

export const validationSchema = Yup.object().shape({
    householdMembers: Yup.array().of(householdMember),
});
